import React, { useEffect } from "react";

import { Slide, SlideProps, Snackbar, SnackbarCloseReason, SnackbarOrigin } from "@mui/material";
import MuiAlert, { AlertColor, AlertProps } from "@mui/material/Alert";

// import SnackbarManagerStyles from './SnackbarManager.styles';
import { useAction } from "src/hooks/useAction";
import { EnumSnackbarType, SnackbarType, SnackbarTypeFields } from "src/stores/reducer/snackbarReducer";
import { useTypedSelector } from "src/hooks/useTypedSelector";

type TransitionProps = Omit<SlideProps, 'direction'>;

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
    props,
    ref,
) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function SlideTransition(props: TransitionProps) {
    return <Slide {...props} direction="up" />;
}

function SnackbarManager() {
    const { clearSnackbar, removeSnackbar } = useAction();
    const { stackSnackbar, snackbarRecentlyAdded } = useTypedSelector((state) => state.snackbar);

    // const classes = SnackbarManagerStyles();
    const timeToLiveInMilliseconds = 5000;
    const hideDurationInMilliseconds = 10000;
    const positionSnackbar: SnackbarOrigin = { vertical: 'bottom', horizontal: 'left' };

    const getSeverityByType = (type: EnumSnackbarType): AlertColor => {
        switch (type) {
            case EnumSnackbarType.ERROR:
                return "error";

            case EnumSnackbarType.SUCCESS:
                return "success";

            case EnumSnackbarType.WARNING:
                return "warning";

            case EnumSnackbarType.INFO:
            default:
                return "info";
        }
    }

    const removeByIndex = (index: number) => removeSnackbar(index);

    const handleClose = (index: number, event?: React.SyntheticEvent<any> | Event, reason?: SnackbarCloseReason) => {
        if (reason === 'clickaway') {
            return;
        }

        removeByIndex(index)
    }

    const removeAllSnackbar = (event?: React.SyntheticEvent<any> | Event, reason?: SnackbarCloseReason) => {
        if (reason === 'clickaway') {
            return;
        }

        clearSnackbar();
    };

    useEffect(() => {
        if ((stackSnackbar.length <= 0) && (!snackbarRecentlyAdded)) return;

        const lastSnackbar: SnackbarType = stackSnackbar[stackSnackbar.length - 1];

        const timeout = setTimeout(() => {
            const indexToRemove = stackSnackbar.findIndex(x => x === lastSnackbar);

            if (indexToRemove >= 0)
                removeByIndex(indexToRemove);

            clearTimeout(timeout);
        }, timeToLiveInMilliseconds)
    }, [stackSnackbar, snackbarRecentlyAdded]);

    return (
        <Snackbar open={stackSnackbar.length > 0}
            onClose={removeAllSnackbar}
            anchorOrigin={positionSnackbar}
            TransitionComponent={SlideTransition}
            autoHideDuration={hideDurationInMilliseconds}
        >
            <div>
                {

                    stackSnackbar.map((one, index) => (
                        <Alert onClose={(e?: React.SyntheticEvent<any> | Event, r?: SnackbarCloseReason) => handleClose(index, e, r)}
                            severity={getSeverityByType(one[SnackbarTypeFields.Type])}

                            // className={classes.snackbarAlert}
                            variant={"standard"}
                            key={`snackbarAlert_${one[SnackbarTypeFields.Type]}_${index}`}
                        >
                            {one[SnackbarTypeFields.Message]}
                        </Alert>
                    ))
                }
            </div>
        </Snackbar>
    );
}

export default SnackbarManager;